import invokeClient from './invokeClient';
export const getAppRegion = () => {
    return invokeClient.invoke({
        functionName: 'getAppRegion',
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vbGliL3JlZ2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFlBQVksTUFBTSxnQkFBZ0IsQ0FBQztBQUUxQyxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQUcsR0FBRyxFQUFFO0lBQy9CLE9BQU8sWUFBWSxDQUFDLE1BQU0sQ0FBQztRQUN6QixZQUFZLEVBQUUsY0FBYztLQUM3QixDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==